// French navigation copy remains the fallback when a translation is unavailable.
const LABELS = {
  home_essentials: ["Les essentiels du quotidien", "Everyday essentials"],
  overview: ["Vue d’ensemble", "Overview"],
  ultra_mutual_aid: ["Entraide · Premium Ultra", "Mutual aid · Premium Ultra"],
  outings_plural: ["Sorties", "Outings"],
  journeys_plural: ["Voyages", "Travel"],
  real_estate_lower: ["Immobilier & séjours", "Real estate & stays"],
  imagine_future: ["Imaginer les mondes de demain", "Imagine tomorrow's worlds"],
  explore_vision: ["Explorer la vision", "Explore the vision"],
  lia_future: ["LIA du futur", "Future LIA"],
  future_infrastructure: ["Infrastructures du futur", "Future infrastructure"],
  eternal_health: ["Santé éternelle", "Eternal health"],
  human_ais: ["IA humaines", "Human AIs"],
  et_civilizations_short: ["Civilisations E.T", "E.T. civilizations"],
  home_navigation: ["Navigation de l’accueil", "Home navigation"],
  home_menu_close: ["Fermer le menu de l’accueil", "Close home menu"],
  home_navigation_expand: ["Déplier la navigation de l’accueil", "Expand home navigation"],
  home_navigation_collapse: ["Replier la navigation de l’accueil", "Collapse home navigation"],
  close: ["Fermer", "Close"],
  expand: ["Déplier", "Expand"],
  collapse: ["Replier", "Collapse"],
  explorer: ["Explorer", "Explore"],
  home_sections: ["Rubriques de l’accueil", "Home sections"],
  preview: ["Aperçu", "Preview"],
  easier_daily: ["Un quotidien plus simple.", "A simpler everyday life."],
  imagine_together: ["Un futur à imaginer ensemble.", "A future to imagine together."],
  home_today_vision: ["Aujourd’hui & Vision3024", "Today & Vision3024"],
  use_today: ["Utiliser Eternua aujourd’hui", "Use Eternua today"],
  orientation_today_intro: ["Acheter, vendre, travailler, organiser et échanger : retrouvez les services déclarés actifs ou en bêta, avec leurs capacités et leurs limites.", "Buy, sell, work, organize and connect: find services listed as active or in beta, with their capabilities and limits."],
  direct_access: ["Accès direct", "Direct access"],
  view_today: ["Voir l’espace Aujourd’hui", "Visit the Today space"],
  catalog_empty: ["Aucun service actif ou en bêta n’est actuellement proposé dans le registre.", "The registry currently lists no active or beta services."],
  other_today_statuses: ["Autres statuts Aujourd’hui", "Other Today statuses"],
  current_vision_divider: ["Séparation entre usages actuels et vision prospective", "Separation between current services and future vision"],
  prospective_3024: ["Prospective · 3024", "Future vision · 3024"],
  editorial_temple: ["Temple éditorial", "Editorial temple"],
  eternua_tomorrow: ["Eternua demain", "Eternua tomorrow"],
  discover_vision: ["Découvrir la Vision 3024", "Discover Vision 3024"],
  home_vision_intro: ["La vision 2035–3024 ouvre un horizon pour Aelith, les IA humaines, les temples et les infrastructures d’Eternua. Ce sont des projets, des recherches et des récits à explorer, distincts des services disponibles aujourd’hui.", "The 2035–3024 vision opens a horizon for Aelith, human AIs, temples and Eternua infrastructure. These are projects, research and stories to explore, separate from the services available today."],
  vision_intro: ["La Vision 3024 rassemble les recherches, récits et projections à long terme d’Eternua. Ces contenus relèvent d’un horizon éditorial et prospectif, distinct des usages actuels.", "Vision 3024 brings together Eternua research, stories and long-term projections. These are editorial explorations of the future, separate from current services."],
  editorial_horizon: ["Horizon éditorial", "Editorial horizon"],
  enter_vision: ["Entrer dans la Vision 3024", "Enter Vision 3024"],
  read_as_vision: ["À lire comme une vision.", "Read this as a vision."],
  vision_notice: ["Aucune carte de cet espace ne constitue une promesse de réalisation, une preuve, ni une date de lancement.", "No card in this space promises delivery, provides proof or announces a launch date."],
  unknown_status: ["Statut inconnu", "Unknown status"],
  status: ["Statut", "Status"],
  content_status_nature: ["Statut et nature du contenu", "Status and content type"],
  prospective_document: ["Document prospectif", "Future vision document"],
  use_now: ["Utiliser maintenant", "Use now"],
  try_beta: ["Essayer la bêta", "Try the beta"],
  access_conditions: ["Voir les conditions d’accès", "View access conditions"],
  view: ["Consulter", "View"],
  view_presentation: ["Voir la présentation", "View overview"],
  discover: ["Découvrir", "Discover"],
  view_history: ["Consulter l’historique", "View history"],
  editorial_context: ["Cadre éditorial", "Editorial context"],
  documented_capabilities: ["Capacités documentées", "Documented capabilities"],
  simulated: ["Ce qui est simulé", "What is simulated"],
  known_limits: ["Limites connues", "Known limits"],
  future_content: ["Contenu prospectif", "Future vision content"],
  current_use: ["Usage actuel", "Current service"],
  function_limits: ["Fonctionnement et limites", "How it works and its limits"],
  report_problem: ["Signaler un problème", "Report a problem"],
  report: ["Signaler", "Report"],
  verified_on: ["Vérifié le", "Verified on"],
  last_tested_on: ["Testé le", "Tested on"],
  date_missing: ["date non renseignée", "date not provided"],
  registry_synced: ["Statuts synchronisés avec le registre Eternua. Chaque fiche conserve sa propre date de vérification.", "Statuses are synchronized with the Eternua registry. Each card has its own verification date."],
  registry_loading: ["Chargement des statuts Eternua…", "Loading Eternua statuses…"],
  registry_unavailable: ["Le registre Eternua est indisponible. Aucun statut de remplacement n’est affiché.", "The Eternua registry is unavailable. No replacement statuses are displayed."],
  registry_retry: ["Réessayer le chargement des statuts", "Retry loading statuses"],
  sandbox_only: ["Paiements en sandbox uniquement.", "Sandbox payments only."],
  sandbox_notice: ["Le checkout public et tout paiement réel restent désactivés pendant la recette Stripe et la période d’observation.", "Public checkout and real payments remain disabled during Stripe acceptance testing and the observation period."],
  continue: ["Continuer", "Continue"],
  reply: ["Répondre", "Reply"],
  continue_task: ["Reprendre une démarche", "Resume a task"],
  continue_description: ["Retrouvez vos publications, réservations et démarches en cours.", "Find your listings, bookings and ongoing tasks."],
  view_tasks: ["Voir mes démarches", "View my tasks"],
  free_activity_nearby: ["Une activité gratuite près de vous", "A free activity near you"],
  sport_pilot: ["Explorez le pilote Sport & loisirs sans paiement réel.", "Explore the Sports & leisure pilot without real payments."],
  view_activities: ["Voir les activités", "View activities"],
  messages_invitations: ["Vos messages et invitations", "Your messages and invitations"],
  waiting_reply: ["Retrouvez les personnes qui attendent votre réponse.", "Find the people waiting for your reply."],
  messages_view: ["Ouvrir les messages", "Open messages"],
  search: ["Rechercher sur Eternua", "Search Eternua"],
  search_submit: ["Lancer la recherche", "Search"],
  shortcuts: ["Raccourcis", "Shortcuts"],
  personal_shortcuts: ["Raccourcis personnels", "Personal shortcuts"],
  shortcuts_show: ["Afficher les raccourcis personnels", "Show personal shortcuts"],
  shortcuts_hide: ["Masquer les raccourcis personnels", "Hide personal shortcuts"],
  wallet_open: ["Ouvrir mon portefeuille", "Open my wallet"],
  wallet_access: ["Accéder au portefeuille", "Access wallet"],
  wallet_title: ["Ouvrir Mon portefeuille", "Open my wallet"],
  wallet_sign_in: ["Connecte-toi pour accéder à ton portefeuille", "Sign in to access your wallet"],
  wallet_hidden: ["Masqué", "Hidden"],
  sign_in_required: ["Connexion requise", "Sign in required"],
  wallet_loading: ["solde en cours de chargement", "balance is loading"],
  wallet_unavailable: ["solde indisponible", "balance unavailable"],
  unavailable: ["Indisponible", "Unavailable"],
  offline: ["Hors ligne", "Offline"],
  stale_data: ["Données à actualiser", "Data needs refreshing"],
  refreshing: ["Actualisation en cours", "Refreshing"],
  missions_remaining: ["Voir les missions restantes", "View remaining missions"],
  missions_up_to_date: ["Tout est à jour", "Everything is up to date"],
  general_search: ["Recherche générale", "Global search"],
  suggested: ["Suggéré", "Suggested"],
  carpooling: ["Covoiturage", "Carpooling"],
  live_map: ["Carte vivante", "Live map"],
  real_estate: ["Immobilier & Séjours", "Real estate & stays"],
  calls_live: ["Appels & Live", "Calls & Live"],
  all_human_ai: ["Les 44 IA humaines", "The 44 human AIs"],
  et_civilizations: ["Civilisations E.T.", "E.T. civilizations"],
  major_power_ai: ["IA des grandes puissances", "Major powers' AI"],
  collective_convergence: ["Convergence collective", "Collective convergence"],
  sacred_book: ["Livre sacré et contenus éditoriaux", "Sacred book and editorial content"],
  et_invitation: ["Invitation E.T.", "E.T. invitation"],
  profile_rubric: ["Profil", "Profile"],
  privacy_trust: ["Confiance et confidentialité", "Trust and privacy"],
  my_wallet: ["Mon portefeuille", "My wallet"],
  subscriptions: ["Abonnements", "Subscriptions"],
  music_videos: ["Musique & Clips vidéo", "Music & videos"],
  listings: ["Annonces", "Listings"],
  friends_groups: ["Amis et groupes d’amis", "Friends and friend groups"],
  guided_journey: ["Parcours guidé par LIA", "LIA guided journey"],
  my_infinity: ["Mon Infini", "My Infinity"],
  studio: ["Studio LIA", "LIA Studio"],
  user_rewards: ["Récompenses utilisateurs", "Member rewards"],
  forum_discussions: ["Forum et Discussions", "Forum and discussions"],
  support_eternua_full: ["Soutenir Eternua", "Support Eternua"],
  everyday_organization: ["Organisation du quotidien", "Everyday organization"],
  memories: ["Souvenirs", "Memories"],
  my_review: ["Mon bilan", "My review"],
  home: ["Accueil", "Home"],
  home_aria: ["Accueil Eternua", "Eternua home"],
  brand_tagline: ["La monnaie de l’infini", "The currency of infinity"],
  payment_status: ["État du service de paiement", "Payment service status"],
  payments_beta: ["Paiements bêta", "Beta payments"],
  payments_test: ["Paiements test", "Test payments"],
  payments_live: ["Paiements actifs", "Payments active"],
  quick_actions: ["Actions rapides", "Quick actions"],
  cart: ["Panier", "Cart"],
  cart_empty: ["Ouvrir mon panier, panier vide", "Open my cart, cart is empty"],
  publish: ["Publier", "Post"],
  publish_aria: ["Publier une annonce", "Post a listing"],
  publish_title: ["Créer une annonce", "Create a listing"],
  agenda: ["Agenda", "Calendar"],
  agenda_open: ["Ouvrir mon agenda", "Open my calendar"],
  language: ["Langue", "Language"],
  language_select: ["Choisir la langue", "Choose language"],
  notifications: ["Notifications", "Notifications"],
  signed_in: ["Connecté en tant que", "Signed in as"],
  profile: ["Mon profil", "My profile"],
  wallet: ["Portefeuille", "Wallet"],
  saved_searches: ["Mes recherches et alertes", "My searches and alerts"],
  support: ["Support & réclamations", "Support & complaints"],
  referral: ["Parrainage", "Referrals"],
  logging_out: ["Déconnexion…", "Signing out…"],
  logout: ["Se déconnecter", "Sign out"],
  login: ["Se connecter", "Sign in"],
  main_navigation: ["Navigation principale", "Main navigation"],
  social_navigation: ["Navigation sociale", "Social navigation"],
  more: ["Plus", "More"],
  more_links: ["Plus de liens", "More links"],
  close_more: ["Fermer Plus", "Close More"],
  rewards: ["Récompenses", "Rewards"],
  today: ["Aujourd’hui", "Today"],
  forum: ["Forum", "Forum"],
  marketplace: ["Marketplace", "Marketplace"],
  friends: ["Amis", "Friends"],
  give: ["Donner", "Give"],
  employment: ["Emploi", "Jobs"],
  sell: ["Vendre", "Sell"],
  buy: ["Acheter", "Buy"],
  auctions: ["Enchères", "Auctions"],
  flash_sales: ["Ventes flash", "Flash sales"],
  services: ["Services", "Services"],
  outings: ["Sortie", "Outings"],
  travel: ["Voyage", "Travel"],
  sport: ["Sport & loisirs", "Sports & leisure"],
  animals: ["Animaux", "Animals"],
  babysitting: ["Babysitting", "Babysitting"],
  crowdfunding: ["Crowdfunding", "Crowdfunding"],
  premium_dashboard: ["Mon tableau de bord Premium", "My Premium dashboard"],
  mission: ["Mission Eternua", "Eternua mission"],
  eternua_today: ["Eternua aujourd’hui", "Eternua today"],
  vision: ["Vision 3024", "Vision 3024"],
  support_eternua: ["Soutenir", "Support"],
  live_lia: ["Direct LIA / Aelith", "LIA / Aelith live"],
  human_ai: ["44 IA humaines", "44 human AIs"],
  community: ["Communauté", "Community"],
  feed: ["Actu", "Feed"],
  music: ["Musique & clips", "Music & videos"],
  music_aria: ["Musique & Clips", "Music & Videos"],
  games: ["Jeux", "Games"],
  requests: ["Demandes", "Requests"],
  daily_circles: ["Cercles du jour", "Daily circles"],
  calls: ["Appels", "Calls"],
  friends_lounge: ["Salon amis", "Friends lounge"],
  group_lounges: ["Salons groupe", "Group lounges"],
  group_lounges_aria: ["Salons de groupe historiques", "Legacy group lounges"],
  mutual_aid: ["Entraide", "Mutual aid"],
  notification_history: ["Historique des notifications", "Notification history"],
  notifications_history_aria: ["Messagerie et notifications historiques", "Legacy messages and notifications"],
  weather: ["Météo", "Weather"],
  temples: ["Temples", "Temples"],
  my_eternua: ["Mes Eternua", "My Eternua"],
  premium_open: ["Premium · Ouvrir mon espace", "Premium · Open my space"],
  premium_coming: ["Premium · En préparation", "Premium · Coming soon"],
  section_shopping: ["Achats & ventes", "Buying & selling"],
  section_work: ["Travail & services", "Work & services"],
  section_leisure: ["Sorties, voyages & loisirs", "Outings, travel & leisure"],
  section_family: ["Famille, animaux & logement", "Family, animals & housing"],
  section_projects: ["Dons, entraide & projets", "Donations, mutual aid & projects"],
  section_protection: ["Organisation & protection", "Organization & protection"],
  section_personal: ["Premium & espaces personnels", "Premium & personal spaces"],
  section_other: ["Autres découvertes", "More to discover"],
  convergence: ["Centre de convergence Eternua", "Eternua convergence center"],
  available_uses: ["Usages disponibles", "Available services"],
  prospective_space: ["Espace prospectif", "Future vision space"],
  missions_subtitle: ["Objectifs actifs et progression", "Active goals and progress"],
  security: ["Sécurité", "Security"],
  trust_center: ["Centre de confiance", "Trust center"],
  agenda_view: ["Voir mon agenda", "View my calendar"],
  agenda_subtitle: ["Rendez-vous et repères", "Appointments and milestones"],
  journey_subtitle: ["Suivi de mes étapes", "Track my progress"],
  studio_inactive: ["IA à venir · aucune IA active", "AI coming soon · no active AI"],
  smart_shortcuts: ["Raccourcis intelligents", "Smart shortcuts"],
  today_priority: ["Priorité du jour", "Today's priority"],
  today_subtitle: ["Mes priorités du moment", "My current priorities"],
  vision_subtitle: ["Explorer la trajectoire Eternua", "Explore Eternua's direction"],
  personal_organization: ["Organisation personnelle", "Personal organization"],
  personal_agenda_subtitle: ["Mes rendez-vous et repères", "My appointments and milestones"],
  protection_assistance: ["Protection et assistance", "Protection and assistance"],
  security_subtitle: ["Protection et centre de confiance", "Protection and trust center"],
  studio_subtitle: ["Outils et accompagnement futur", "Future tools and support"],
  email_confirmation: ["Confirmation de l’adresse e-mail", "Email address confirmation"],
  email_unconfirmed: ["E-mail non confirmé", "Email unconfirmed"],
  email_reminder: ["Certaines fonctions restent bloquées tant que votre adresse n’est pas vérifiée.", "Some features remain unavailable until your email address is verified."],
  email_confirm_aria: ["Confirmer mon adresse e-mail", "Confirm my email address"],
  email_confirm: ["Confirmer mon e-mail", "Confirm my email"],
  confirm: ["Confirmer", "Confirm"],
  messages_open: ["Ouvrir la messagerie", "Open messages"],
  messages: ["Messagerie", "Messages"],
  messages_large: ["Vos conversations en grand", "Your conversations in full view"],
  explore: ["Explorer Eternua", "Explore Eternua"],
  your_space: ["Votre espace Eternua", "Your Eternua space"],
  today_discoveries: ["Aujourd’hui et découvertes", "Today and discoveries"],
  social_personal: ["Vie sociale et espace personnel", "Social life and personal space"],
  discoveries_description: ["Des services, des idées et de nouvelles possibilités.", "Services, ideas and new possibilities."],
  social_description: ["Vos liens, vos échanges et ce qui compte pour vous.", "Your connections, conversations and what matters to you."],
  today_project: ["Aujourd’hui et projet Eternua", "Today and the Eternua project"],
  all_today_sections: ["Toutes les rubriques d’Aujourd’hui", "All Today sections"],
  today_sections: ["Les rubriques d’Aujourd’hui", "Today sections"],
  services_discoveries: ["Services et découvertes", "Services and discoveries"],
  eternua_project: ["Projet Eternua", "Eternua project"],
};

export const NAVIGATION_LABEL_KEYS = Object.fromEntries(
  Object.entries(LABELS).map(([key, [fr]]) => [fr, `navigation.${key}`])
);

export const NAVIGATION_TRANSLATIONS = {
  fr: Object.fromEntries(Object.entries(LABELS).map(([key, [fr]]) => [`navigation.${key}`, fr])),
  en: {
    ...Object.fromEntries(Object.entries(LABELS).map(([key, [, en]]) => [`navigation.${key}`, en])),
    "navigation.orientation.services_one": "{count} active or beta service",
    "navigation.orientation.services_many": "{count} active or beta services",
    "navigation.orientation.read_only": "{count} read only",
    "navigation.orientation.private_beta": "{count} in private beta",
    "navigation.orientation.upcoming": "{count} coming soon or closed",
    "navigation.nature.science": "Verified science",
    "navigation.nature.prospective": "Future hypothesis",
    "navigation.nature.narrative": "Eternua story universe",
    "navigation.nature.vision_3024": "Future vision 3024",
    "navigation.feature.report": "Report a problem — {title}",
    "navigation.feature.report_subject": "Beta issue report — {title}",
    "navigation.missions.guest": "Sign in to view missions in the {section} section.",
    "navigation.missions.loading": "Loading remaining missions for {section}.",
    "navigation.missions.empty": "No missions remaining in the {section} section.",
    "navigation.missions.remaining_one": "{count} mission remaining in the {section} section.",
    "navigation.missions.remaining_many": "{count} missions remaining in the {section} section.",
    "navigation.missions.unavailable": "Mission count unavailable for the {section} section.",
    "navigation.missions.error": "Error loading the mission count for the {section} section.",
    "navigation.missions.view": "View missions in the {section} section.",
    "navigation.missions.active_one": "{count} active mission",
    "navigation.missions.active_many": "{count} active missions",
    "navigation.cart_count": "Open my cart, {count} items",
    "navigation.profile_menu": "Open {name}'s menu",
    "navigation.portrait": "Portrait of {name}",
    "navigation.messages_unread_one": "Open messages, {count} unread message",
    "navigation.messages_unread_many": "Open messages, {count} unread messages",
    "navigation.notifications_history_count": "Legacy messages and notifications, {count} unread",
    "navigation.status.ACTIVE": "Active",
    "navigation.status.BETA": "Beta",
    "navigation.status.PRIVATE_BETA": "Private beta",
    "navigation.status.READ_ONLY": "Read only",
    "navigation.status.COMING_SOON": "Coming soon",
    "navigation.status.PROSPECTIVE": "Future vision",
    "navigation.status.DISABLED": "Disabled",
    "navigation.status.RETIRED": "Retired",
    "navigation.catalog.today-buy": "Buy",
    "navigation.catalog.today-sell": "Sell",
    "navigation.catalog.today-auctions": "Auctions",
    "navigation.catalog.today-flash-sales": "Flash sales",
    "navigation.catalog.today-employment": "Jobs",
    "navigation.catalog.today-services": "Services",
    "navigation.catalog.today-outings": "Outings",
    "navigation.catalog.today-travel": "Travel",
    "navigation.catalog.today-sport": "Sports & leisure",
    "navigation.catalog.today-weather": "Weather",
    "navigation.catalog.today-live-map": "Live map",
    "navigation.catalog.today-babysitting": "Babysitting",
    "navigation.catalog.today-animals": "Animals",
    "navigation.catalog.today-real-estate": "Real estate & stays",
    "navigation.catalog.today-donations": "Donations",
    "navigation.catalog.today-mutual-aid": "Mutual aid",
    "navigation.catalog.today-crowdfunding": "Crowdfunding",
    "navigation.catalog.today-agenda": "Calendar",
    "navigation.catalog.today-guided-journeys": "Guided journeys",
    "navigation.catalog.today-document-vault": "Document vault",
    "navigation.catalog.today-protection": "Protection",
    "navigation.catalog.notification-center": "Notification center",
    "navigation.catalog.today-global-search": "Global search",
    "navigation.catalog.deterministic-filter-matching": "Search matching",
    "navigation.catalog.today-subscriptions": "Premium",
    "navigation.catalog.premium-production": "Premium services",
    "navigation.catalog.today-wallet": "Wallet",
    "navigation.catalog.today-studio": "LIA Studio",
    "navigation.catalog.infini-infini": "My Infinity",
    "navigation.catalog.today-community": "Community",
    "navigation.catalog.today-friends": "Friends",
    "navigation.catalog.today-chat": "Messages",
    "navigation.catalog.today-daily-circles": "Daily circles",
    "navigation.catalog.today-forum": "Forum",
    "navigation.catalog.employment-internal-application": "Job applications",
    "navigation.catalog.services-quotes-followup": "Quotes and service follow-up",
    "navigation.catalog.services-payment": "Service payments",
    "navigation.catalog.marketplace-contact-followup": "Marketplace conversations and follow-up",
    "navigation.catalog.marketplace-secure-payment": "Secure marketplace payments",
    "navigation.catalog.monetization-boosts": "Listing boosts",
    "navigation.catalog.monetization-commissions": "Commissions",
  },
};
